// app/(auth)/connexion/page.tsx
import AuthForm from "../../components/shared/auth/AuthForm";


export default function LoginPage() {
  return <AuthForm type="login" />;
}